'use client'

import { useJourneyValues } from '@ccpgames/eve-web-hooks'
import { usePathname, useSearchParams } from 'next/navigation'

export default function JourneyManagerBootstrapClient() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useJourneyValues({
    landingPage: pathname,
    query: searchParams,
  })

  return null
}
